/**
 * Angular imports.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { GetService } from '../../dataservices/get.service';

/**
 * Rxjs imports.
 */
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Modal imports.
 */
import { CommunityListResponse } from './../../onboarding/interface/apiResponse.model';

/**
 * Constant imports.
 */
import { COMMUNITY_LIST_TYPE, NUMBERS } from './../../constants/app.constants';

/**
 * Resolver Guard to get the post detail.
 */
@Injectable({
  providedIn: 'root'
})
export class CommunityListGuard {

  /**
   * Instance of store, Action.
   */
  constructor(
    private router: Router,
    private getApiService: GetService
  ) { }

  resolve(): Observable<CommunityListResponse[]> {
    return combineLatest([
      this.getApiService.getCommunityList(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, '1'),
      this.getApiService.getCommunityList(COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY, '1')]).pipe(
        map(([communityList, publicCommunityList]) => {
          if (communityList.status === NUMBERS.ONE && publicCommunityList.status === NUMBERS.ONE) {
            return [communityList, publicCommunityList];
          } else {
            console.log('Error', [communityList, publicCommunityList]);
          }
        })
      );
  }
}
